(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-checkout"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-delivery-checkout]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    document.title = 'Delivery Info – Chris Petals';
    var form = root.querySelector('[data-delivery-form]');
    var dateInput = root.querySelector('[data-delivery-input]');
    var zipInput = root.querySelector('[data-zip-input]');
    var zipConfirm = root.querySelector('[data-zip-confirm]');
    var note = root.querySelector('[data-delivery-note]');
    var error = root.querySelector('[data-delivery-error]');
    var pay = root.querySelector('[data-delivery-pay]');
    var message = form.querySelector('[name="message"]');
    var messageCount = root.querySelector('[data-message-count]');
    var ZONE = 'America/New_York';
    var MONTHS = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };

    function parts(date, extra) {
      var bag = {};
      new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: ZONE, hourCycle: 'h23' }, extra)).formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') bag[part.type] = part.value;
      });
      return bag;
    }

    function shift(now, days, months) {
      var date = new Date(Date.UTC(Number(now.year), Number(now.month) - 1 + (months || 0), Number(now.day) + (days || 0), 17, 0, 0));
      var bag = parts(date, { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' });
      var named = parts(date, { month: 'short', day: 'numeric', weekday: 'short' });
      bag.iso = bag.year + '-' + bag.month + '-' + bag.day;
      bag.short = named.weekday + ', ' + named.month + ' ' + named.day;
      bag.label = bag.short + ', ' + bag.year;
      return bag;
    }

    function bounds() {
      var now = parts(new Date(), { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', weekday: 'short' });
      var openDay = now.weekday === 'Mon' || now.weekday === 'Tue' || now.weekday === 'Wed' || now.weekday === 'Thu' || now.weekday === 'Fri';
      var open = openDay && Number(now.hour) < 14;
      var earliest = shift(now, open ? 0 : 1, 0);
      var latest = shift({ year: earliest.iso.slice(0, 4), month: earliest.iso.slice(5, 7), day: earliest.iso.slice(8, 10) }, 0, 6);
      return { open: open, earliest: earliest, latest: latest, weekday: now.weekday };
    }

    function labelToIso(label) {
      var match = String(label || '').match(/([A-Za-z]{3}) (\d{1,2}), (\d{4})/);
      if (!match || !MONTHS[match[1]]) return '';
      var day = match[2].length === 1 ? '0' + match[2] : match[2];
      return match[3] + '-' + MONTHS[match[1]] + '-' + day;
    }

    function ensureZipData(src) {
      if (window.cpHasUsZip) return Promise.resolve();
      if (!src) return Promise.reject(new Error('zip'));
      if (!window.cpZipLoading) {
        window.cpZipLoading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = src;
          script.onload = function () {
            if (window.cpHasUsZip) resolve();
            else reject(new Error('zip'));
          };
          script.onerror = function () { reject(new Error('zip')); };
          document.head.appendChild(script);
        });
      }
      return window.cpZipLoading;
    }

    function normalizeZip(value) {
      var cleaned = String(value || '').replace(/\s+/g, '');
      if (/^\d{5}$/.test(cleaned)) return cleaned;
      if (/^\d{5}-\d{4}$/.test(cleaned)) return cleaned;
      if (/^\d{9}$/.test(cleaned)) return cleaned.slice(0, 5) + '-' + cleaned.slice(5);
      return '';
    }

    function phoneDigits(value) {
      var digits = String(value || '').replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? digits : '';
    }

    function showError(text) {
      error.hidden = false;
      error.textContent = text;
    }

    function placeContext(ok, formatted) {
      if (!window.cpPlace) return { zone: 'America/New_York', known: false, place: '', zip: false };
      if (!zipInput.value.trim()) window.cpPlace.clearZip();
      if (ok) return window.cpPlace.noteContext(true, formatted);
      return window.cpPlace.noteContext(false, '');
    }

    function syncDate() {
      var formatted = normalizeZip(zipInput.value);
      var ok = !!(formatted && window.cpHasUsZip && window.cpHasUsZip(formatted.slice(0, 5)));
      var place = placeContext(ok, formatted);
      ZONE = place.zone;
      var range = bounds();
      dateInput.min = range.earliest.iso;
      dateInput.max = range.latest.iso;
      if (!dateInput.value || dateInput.value < range.earliest.iso || dateInput.value > range.latest.iso) {
        dateInput.value = range.earliest.iso;
      }
      note.textContent = window.cpPlace
        ? window.cpPlace.deliveryNote({
          zone: place.zone,
          known: place.known,
          place: place.place,
          zip: place.zip,
          open: range.open,
          weekday: range.weekday,
          earliest: range.earliest.short
        })
        : 'Enter the delivery ZIP to see if same-day delivery is still open.';
      return range;
    }

    function syncZip() {
      var formatted = normalizeZip(zipInput.value);
      if (!formatted) {
        zipConfirm.hidden = true;
        zipConfirm.textContent = '';
        return;
      }
      ensureZipData(root.getAttribute('data-zip-src')).then(function () {
        if (normalizeZip(zipInput.value) !== formatted) return;
        if (window.cpHasUsZip(formatted.slice(0, 5))) {
          syncDate();
          zipConfirm.hidden = false;
          zipConfirm.textContent = 'A local florist will deliver to ' + formatted + '. ' + note.textContent;
        } else {
          zipConfirm.hidden = true;
          zipConfirm.textContent = '';
        }
      }).catch(function () {});
    }

    function countMessage() {
      var left = 230 - message.value.length;
      messageCount.textContent = left + ' characters remaining';
    }

    var savedDate = labelToIso(root.dataset.savedDate);
    if (savedDate) dateInput.value = savedDate;
    if (window.cpPlace && !zipInput.value) {
      var savedPlace = window.cpPlace.read();
      if (savedPlace && savedPlace.zip) zipInput.value = savedPlace.zip;
    }
    syncDate();
    syncZip();
    countMessage();
    dateInput.addEventListener('change', function () {
      error.hidden = true;
      syncDate();
    });
    zipInput.addEventListener('input', function () {
      error.hidden = true;
      syncZip();
      syncDate();
    });
    message.addEventListener('input', countMessage);

    function field(name) {
      return form.querySelector('[name="' + name + '"]').value.trim();
    }

    function rootPath() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function dateLabel() {
      var picked = shift({
        year: dateInput.value.slice(0, 4),
        month: dateInput.value.slice(5, 7),
        day: dateInput.value.slice(8, 10)
      }, 0, 0);
      return picked.label;
    }

    pay.addEventListener('click', function () {
      error.hidden = true;
      var range = syncDate();
      var zip = normalizeZip(zipInput.value);
      var phone = phoneDigits(field('phone'));
      if (!field('first') || !field('last')) {
        showError('Enter the recipient’s first and last name.');
        return;
      }
      if (!field('address') || !field('city') || !field('state')) {
        showError('Enter the delivery street, city, and state.');
        return;
      }
      if (!zip) {
        showError(zipInput.value.trim()
          ? 'Enter a US ZIP code. Codes outside the United States are not accepted.'
          : 'Enter a delivery ZIP code.');
        zipInput.focus();
        return;
      }
      if (!phone) {
        showError('Enter a 10-digit US phone number for the delivery.');
        return;
      }
      if (dateInput.value < range.earliest.iso) {
        showError('Choose ' + range.earliest.short + ' or a later date.');
        return;
      }
      pay.disabled = true;
      ensureZipData(root.getAttribute('data-zip-src')).then(function () {
        if (!window.cpHasUsZip(zip.slice(0, 5))) {
          pay.disabled = false;
          showError('Enter a recognized US ZIP code.');
          zipInput.focus();
          return;
        }
        var details = {
          first: field('first'),
          last: field('last'),
          address: field('address'),
          apartment: field('apartment'),
          city: field('city'),
          state: field('state'),
          zip: zip,
          phone: phone,
          location: field('location'),
          occasion: field('occasion'),
          instructions: field('instructions'),
          message: message.value.trim(),
          date: dateLabel()
        };
        return fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var index = 0;
            function nextItem() {
              if (index >= cart.items.length) return Promise.resolve();
              var item = cart.items[index];
              index += 1;
              var properties = Object.assign({}, item.properties || {});
              delete properties['Preferred delivery time'];
              properties['Delivery date'] = details.date;
              properties['Delivery zip code'] = details.zip;
              properties['Recipient name'] = details.first + ' ' + details.last;
              properties['Delivery phone'] = details.phone;
              properties['Location type'] = details.location;
              if (details.instructions) properties['Delivery instructions'] = details.instructions;
              else delete properties['Delivery instructions'];
              return fetch(rootPath() + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
              }).then(function (response) {
                if (!response.ok) throw new Error('cart');
                return nextItem();
              });
            }
            return nextItem();
          })
          .then(function () {
            return fetch(rootPath() + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                note: details.message,
                attributes: {
                  'Delivery date': details.date,
                  'Delivery zip code': details.zip,
                  'Recipient first name': details.first,
                  'Recipient last name': details.last,
                  'Delivery address': details.address,
                  'Apartment': details.apartment,
                  'Delivery city': details.city,
                  'Delivery state': details.state,
                  'Delivery phone': details.phone,
                  'Location type': details.location,
                  'Occasion': details.occasion,
                  'Delivery instructions': details.instructions
                }
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('cart');
            var params = new URLSearchParams();
            params.set('checkout[shipping_address][country]', 'US');
            params.set('checkout[shipping_address][first_name]', details.first);
            params.set('checkout[shipping_address][last_name]', details.last);
            params.set('checkout[shipping_address][address1]', details.address);
            if (details.apartment) params.set('checkout[shipping_address][address2]', details.apartment);
            params.set('checkout[shipping_address][city]', details.city);
            params.set('checkout[shipping_address][province]', details.state);
            params.set('checkout[shipping_address][zip]', details.zip);
            params.set('checkout[shipping_address][phone]', details.phone);
            window.location.assign(rootPath() + 'checkout?' + params.toString());
          });
      }).catch(function () {
        pay.disabled = false;
        showError('The delivery details could not be saved. Try again.');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  (function () {
    var note = document.querySelector('.next-day-bar .next-day-text');
    if (!note) return;

    var SHORT = {
      'America/New_York': 'ET',
      'America/Chicago': 'CT',
      'America/Denver': 'MT',
      'America/Phoenix': 'MST',
      'America/Los_Angeles': 'PT',
      'America/Anchorage': 'AKT',
      'Pacific/Honolulu': 'HT',
      'America/Indiana/Indianapolis': 'ET',
      'America/Detroit': 'ET',
      'America/Boise': 'MT'
    };
    var zipError = '';
    var form = document.querySelector('.next-day-bar .next-day-zip');
    var zipInput = document.getElementById('HeaderDeliveryZip');
    var zipButton = form ? form.querySelector('button') : null;

    function setChecking(busy) {
      if (!zipButton) return;
      zipButton.disabled = busy;
      if (busy) zipButton.setAttribute('aria-busy', 'true');
      else zipButton.removeAttribute('aria-busy');
    }

    function savedZip() {
      if (!window.cpPlace || !window.cpPlace.read) return null;
      var saved = window.cpPlace.read();
      if (saved && saved.manual && saved.source === 'zip' && saved.zip && saved.zone) return saved;
      return null;
    }

    function parts(date, zone) {
      var map = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: zone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(date).forEach(function (part) {
        map[part.type] = part.value;
      });
      if (map.hour === '24') map.hour = '00';
      return map;
    }

    function dayLabel(nowParts, days) {
      var next = new Date(Date.UTC(+nowParts.year, +nowParts.month - 1, +nowParts.day + days, 12, 0, 0));
      return new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC',
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      }).format(next);
    }

    function normalizeZip(value) {
      var cleaned = String(value || '').replace(/\D/g, '');
      if (/^\d{5}$/.test(cleaned) || /^\d{9}$/.test(cleaned)) return cleaned.slice(0, 5);
      return '';
    }

    function ensureZipData() {
      if (window.cpHasUsZip) return Promise.resolve();
      var src = document.querySelector('.next-day-bar').getAttribute('data-zip-src');
      if (!src) return Promise.reject(new Error('zip'));
      if (!window.cpZipLoading) {
        window.cpZipLoading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = src;
          script.onload = function () {
            if (window.cpHasUsZip) resolve();
            else reject(new Error('zip'));
          };
          script.onerror = function () { reject(new Error('zip')); };
          document.head.appendChild(script);
        });
      }
      return window.cpZipLoading;
    }

    function offerLine(zone) {
      var nowParts = parts(new Date(), zone || 'America/New_York');
      var weekend = nowParts.weekday === 'Fri' || nowParts.weekday === 'Sat' || nowParts.weekday === 'Sun';
      return weekend ? 'Free shipping.' : 'Free shipping.';
    }

    function deliveryStatus(saved) {
      var nowParts = parts(new Date(), saved.zone);
      var short = SHORT[saved.zone] || 'local time';
      var minutes = (+nowParts.hour * 60) + +nowParts.minute;
      var openDays = { Mon: true, Tue: true, Wed: true, Thu: true, Fri: true };
      if (nowParts.weekday === 'Sat' || nowParts.weekday === 'Sun') {
        var skip = nowParts.weekday === 'Sat' ? 2 : 1;
        return {
          state: 'closed',
          text: 'Same-day to ' + saved.zip + ' is closed today; next delivery ' + dayLabel(nowParts, skip) + '.'
        };
      }
      if (openDays[nowParts.weekday] && minutes < 14 * 60) {
        return {
          state: 'open',
          text: 'Same-day to ' + saved.zip + ' until 2:00 PM ' + short + '.'
        };
      }
      return {
        state: 'closed',
        text: 'Same-day to ' + saved.zip + ' has closed; next delivery ' + dayLabel(nowParts, 1) + '.'
      };
    }

    function render() {
      var saved = savedZip();
      var offer = offerLine(saved ? saved.zone : 'America/New_York');
      var lead = offer;
      if (zipError) lead += ' ' + zipError;
      else if (!saved) lead += ' Enter a ZIP to check same-day delivery.';
      note.textContent = lead;
      if (saved && !zipError) {
        var status = deliveryStatus(saved);
        var mark = document.createElement('span');
        mark.className = 'next-day-status next-day-status--' + status.state;
        mark.textContent = status.text;
        note.appendChild(document.createTextNode(' '));
        note.appendChild(mark);
      }
      if (zipInput && document.activeElement !== zipInput && saved && !zipError) zipInput.value = saved.zip;
    }

    var cityStates = {al:1,ak:1,az:1,ar:1,ca:1,co:1,ct:1,de:1,dc:1,fl:1,ga:1,hi:1,id:1,il:1,in:1,ia:1,ks:1,ky:1,la:1,me:1,md:1,ma:1,mi:1,mn:1,ms:1,mo:1,mt:1,ne:1,nv:1,nh:1,nj:1,nm:1,ny:1,nc:1,nd:1,oh:1,ok:1,or:1,pa:1,ri:1,sc:1,sd:1,tn:1,tx:1,ut:1,vt:1,va:1,wa:1,wv:1,wi:1,wy:1};

    function cityKey() {
      if (!document.documentElement.classList.contains('place-home')) return '';
      var path = String(location.pathname || '').toLowerCase().replace(/\/+$/, '');
      var page = path.match(/^(?:\/pages)?\/([a-z0-9-]+)-([a-z]{2})$/);
      if (page && cityStates[page[2]]) return page[1] + '-' + page[2];
      var florist = path.match(/^\/florist\/([a-z]{2})\/([a-z0-9-]+)$/);
      if (florist && cityStates[florist[1]]) return florist[2] + '-' + florist[1];
      return '';
    }

    function ensureCityZips() {
      if (window.cpCityZips) return Promise.resolve();
      var src = document.querySelector('.next-day-bar').getAttribute('data-city-src');
      if (!src) return Promise.reject(new Error('city'));
      if (!window.cpCityLoading) {
        window.cpCityLoading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = src;
          script.onload = function () {
            if (window.cpCityZips) resolve();
            else reject(new Error('city'));
          };
          script.onerror = function () { reject(new Error('city')); };
          document.head.appendChild(script);
        });
      }
      return window.cpCityLoading;
    }

    function applyCityZip() {
      var key = cityKey();
      if (!key || !window.cpPlace) return Promise.resolve(false);
      return ensureCityZips().then(function () {
        var saved = window.cpPlace.read() || {};
        if (saved.manual && saved.source === 'zip') return false;
        if (zipInput && document.activeElement === zipInput && String(zipInput.value || '').trim()) return false;
        var zip = window.cpCityZips[key];
        if (!zip) return false;
        window.cpPlace.rememberZip(zip, false);
        render();
        return true;
      }).catch(function () { return false; });
    }

    function locateByNetwork() {
      if (savedZip()) return;
      if (zipInput && String(zipInput.value || '').trim()) return;
      ensureZipData().then(function () {
        if (savedZip()) return;
        return fetch('https://ipwho.is/').then(function (response) {
          return response.json();
        }).then(function (data) {
          if (savedZip()) return;
          if (zipInput && document.activeElement === zipInput && String(zipInput.value || '').trim()) return;
          var postal = data && data.country_code === 'US' ? normalizeZip(data.postal) : '';
          var zip = postal && window.cpHasUsZip(postal) ? postal : '08542';
          if (window.cpPlace) window.cpPlace.rememberZip(zip, false);
          render();
        });
      }).catch(function () {
        if (savedZip()) return;
        if (window.cpPlace) window.cpPlace.rememberZip('08542', false);
        render();
      });
    }

    function locateVisitor() {
      if (cityKey()) {
        applyCityZip().then(function (applied) {
          if (!applied) locateByNetwork();
        });
        return;
      }
      locateByNetwork();
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var entered = zipInput ? zipInput.value : '';
        setChecking(true);
        ensureZipData().then(function () {
          var formatted = normalizeZip(entered);
          if (!formatted) {
            zipError = 'Enter a US ZIP code.';
            render();
            return;
          }
          if (!window.cpHasUsZip(formatted)) {
            zipError = 'Enter a recognized US ZIP code.';
            render();
            return;
          }
          zipError = '';
          if (window.cpPlace) window.cpPlace.rememberZip(formatted, true);
          render();
        }).catch(function () {
          zipError = 'Please try that ZIP code again.';
          render();
        }).finally(function () {
          setChecking(false);
        });
      });
    }

    render();
    locateVisitor();
    setInterval(render, 30000);
    window.addEventListener('cp-place', function () {
      zipError = '';
      render();
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.collection-more-btn');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    var grid = document.querySelector('#product-grid');
    if (!grid) {
      window.location.href = button.href;
      return;
    }
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading flowers…';
    fetch(button.href)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('#product-grid');
        if (!nextGrid) {
          window.location.href = button.href;
          return;
        }
        nextGrid.querySelectorAll('.grid__item').forEach(function (item) {
          grid.appendChild(item);
        });
        var count = document.querySelector('.collection-more-count');
        var nextCount = doc.querySelector('.collection-more-count');
        if (count && nextCount) count.textContent = nextCount.textContent;
        var nextButton = doc.querySelector('.collection-more-btn');
        if (nextButton) {
          button.href = nextButton.getAttribute('href');
          button.textContent = 'Show more flowers';
          button.removeAttribute('aria-busy');
        } else {
          button.remove();
        }
      })
      .catch(function () {
        window.location.href = button.href;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
